import React from 'react';
import {Button, ModalCard} from "@vkontakte/vkui";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {handleSubscribe} from "../../utils/subscription";
import {
    MODAL_CARD_CLASS,
    MODAL_HEADER_CLASS,
    MODAL_PRIMARY_BUTTON_CLASS,
    MODAL_SECONDARY_BUTTON_CLASS,
    MODAL_SUBHEADER_CLASS
} from "../modalStyles";

export const SubscribeToMissionsModal = ({nav}) => {
    const routeNavigator = useRouteNavigator();

    // onSubscribeClick запускает подписку и закрывает модалку в любом случае
    const onSubscribeClick = () => {
        handleSubscribe().then(() => {
            routeNavigator.hideModal();
        }).catch(() => {
            routeNavigator.hideModal();
        });
    };

    return (
        <ModalCard
            nav={nav}
            onClose={() => routeNavigator.hideModal()}
            className={MODAL_CARD_CLASS}
            header={<span className={MODAL_HEADER_CLASS}>Missions are waiting!</span>}
            subheader={
                <span className={MODAL_SUBHEADER_CLASS}>
                    Subscribe to notifications so you do not miss new missions and rewards.
                </span>
            }
            actions={
                <div className={"flex flex-col w-full gap-2"}>
                    <Button size="l"
                            mode="primary"
                            className={`rounded border-solid border-2 border-yellow-400/20 ${MODAL_PRIMARY_BUTTON_CLASS}`}
                            onClick={onSubscribeClick}>
                        Subscribe
                    </Button>
                    <Button
                        size="l"
                        mode="secondary"
                        className={MODAL_SECONDARY_BUTTON_CLASS}
                        onClick={() => routeNavigator.hideModal()}
                    >
                        Later
                    </Button>
                </div>
            }
        />
    );
};
